import React from 'react';
import { FaPencilAlt } from '@react-icons/all-files/fa/FaPencilAlt';
import MoneyFormatter from '../../../commons/componentes/MoneyFormatter';
import DateFormat from '../../../commons/componentes/DateFormat';
import {
  idServicioFromServicioPreciosRow,
  isServicioAsignadoRowInactivo,
  SERVICIO_ASIGNADO_INACTIVO_TEXT_STYLE,
} from './servicio-asignado-form';

const ServicioAsignadoTable = (props: {
  empresaServicios: any[];
  onEditarServicio?: (row: any) => void;
}) => {
  const { empresaServicios, onEditarServicio } = props;
  const list = empresaServicios ?? [];
  const showAcciones = onEditarServicio != null;

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <table className="table tabla-chica" style={{ minWidth: showAcciones ? 580 : 520 }}>
        <thead>
          <tr className="bg-primary">
            <th>Inicio de Servicio</th>
            <th>Proveedor</th>
            <th>Se Factura a</th>
            <th>Servicio</th>
            <th>Último Precio</th>
            <th>Precio</th>
            {showAcciones ? (
              <th className="text-center" style={{ width: 56 }} aria-label="Acciones">
                Acciones
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {list.map((servicioAsignado, index: number) => {
            const inactivo = isServicioAsignadoRowInactivo(servicioAsignado);
            const cellStyle = inactivo ? SERVICIO_ASIGNADO_INACTIVO_TEXT_STYLE : undefined;
            return (
            <tr key={servicioAsignado.idServicio ?? servicioAsignado.id ?? index}>
              <td style={cellStyle}>
                <DateFormat value={servicioAsignado.seraInicio ?? servicioAsignado.fechaInicio} />
              </td>
              <td style={cellStyle}>
                {servicioAsignado.cmpProveedor ?? servicioAsignado.proveedor?.nombre ?? '—'}
              </td>
              <td style={cellStyle}>
                {servicioAsignado.empRazonSocialFactura ??
                  servicioAsignado.seFacturaA?.razonSocial ??
                  '—'}
              </td>
              <td style={cellStyle}>
                {servicioAsignado.servDescripcion ??
                  servicioAsignado.categoriaServicio?.descripcion ??
                  '—'}
              </td>
              <td style={cellStyle}>
                <DateFormat value={servicioAsignado.fechaPrecio} />
              </td>
              <td style={cellStyle}>
                <MoneyFormatter
                  value={servicioAsignado.ultimoPrecio ?? servicioAsignado.precio}
                />
              </td>
              {showAcciones ? (
                <td className="text-center p-1 align-middle">
                  {idServicioFromServicioPreciosRow(servicioAsignado) != null ? (
                    <button
                      type="button"
                      className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                      style={{ width: 34, height: 30, padding: 0 }}
                      title="Editar servicio asignado"
                      aria-label="Editar servicio asignado"
                      onClick={() => onEditarServicio!(servicioAsignado)}
                    >
                      <FaPencilAlt />
                    </button>
                  ) : null}
                </td>
              ) : null}
            </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ServicioAsignadoTable;
